module.exports = __webpack_public_path__ + "img/picture.4d540918.png";